export default __webpack_public_path__ + "static/media/logo.a76d299a.png";